import { type SupabaseClient, createClient } from '@supabase/supabase-js'

/* eslint-disable @typescript-eslint/no-explicit-any */
let client: any = null

async function fetchWithRetry(
  req: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  const retries = 3
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      return await fetch(req, init)
    } catch (error) {
      // Don't retry if it's an abort
      if (init?.signal?.aborted) {
        throw error
      }
      if (attempt === retries) {
        console.error(`Error fetching request ${req}`, error, init)
        throw error
      }
      console.warn(`Retrying fetch attempt ${attempt + 1} for request: ${req}`)
    }
  }
  throw new Error('Unreachable code')
}

export const useSupabaseClient: <T = Supabase>() => SupabaseClient<T> = <
  T = Supabase,
>() => {
  if (!client) {
    const config = useRuntimeConfig()
    const { session } = useSession()

    client = createClient<T>(
      config.public.supabase.url,
      config.public.supabase.key,
      {
        auth: {
          persistSession: false,
          detectSessionInUrl: false,
        },
        global: {
          fetch: fetchWithRetry,
        },
        realtime: {
          worker: true,
          accessToken: async () => (await session.value?.getToken()) ?? null,
        },
        accessToken: async () => (await session.value?.getToken()) ?? null,
      },
    )
  }

  return client
}
